import { ICreateAssistenciaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/create/create_assistencia_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateAssistenciaPesquisaSatisfacaoUseCase
 */

export class CreateAssistenciaPesquisaSatisfacaoUseCase implements ICreateAssistenciaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createAssistenciaPesquisaSatisfacao(
    idAssistenciaTecnica: number,
    idPesquisaSatisfacao: number,
  ): Promise<void> {
    await this.repository.createAssistenciaPesquisaSatisfacao(idAssistenciaTecnica, idPesquisaSatisfacao);
  }
}
